import { render, staticRenderFns } from "./RelationshipListItem.vue?vue&type=template&id=06379fb2&scoped=true"
import script from "./RelationshipListItem.vue?vue&type=script&lang=js"
export * from "./RelationshipListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06379fb2",
  null
  
)

export default component.exports